import React from "react";

export default function PaymentSuccess() {
  return <div>Payment Success</div>;
}
